import script from "./CampoPedirPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoPedirPopup.vue?vue&type=script&setup=true&lang=js"

import "./CampoPedirPopup.vue?vue&type=style&index=0&id=007380c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007380c0"]])

export default __exports__